/* Assemble des elements HTML, sans modifier ni fabriquer de fichier image. */
(()=>{
  'use strict';
  const data=window.ESL_PRODUCT_VISUALS;
  if(!data)return;
  const products=new Map(data.products.map(p=>[p.handle,p]));
  const packs=new Map(Object.entries(data.packs));
  // Un duo de puzzles illustre le rayon Jeux, sans lui ajouter l'eventail d'un pack.
  packs.set('visuel-duo-puzzles',['puzzle-epee-du-courage-100','puzzle-miracle-des-lys-300']);
  const imageKeys=new Map();
  const basename=url=>{try{return new URL(url,location.origin).pathname.split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/,'')}catch{return ''}};
  for(const [handle,parts] of packs){
    const p=products.get(handle);
    if(p&&p.image)imageKeys.set(basename(p.image),handle);
  }
  for(const [key,handle] of Object.entries(data.aliases))imageKeys.set(key,handle);
  for(const key of ['pack-decouverte.jpg','pack-decouverte_fondbleu_20260712.jpg','visuel-pack-decouverte.png'])imageKeys.set(key,'maxi-pack-univers');
  for(const key of ['pack-puzzles.jpg','pack-puzzles_fondbleu_20260712.jpg'])imageKeys.set(key,'visuel-duo-puzzles');
  const coverKeys=new Map();
  for(const p of products.values()){
    if(p.handle.startsWith('je-decouvre-'))coverKeys.set(p.handle+'-1.png',p.handle);
  }
  const heroes={clovis:'clovis-ier',clotilde:'sainte-clotilde',alienor:'alienor-d-aquitaine',francois:'francois-ier',jeanne:'jeanne-d-arc',napoleon:'napoleon-ier'};
  for(const [hero,suffix] of Object.entries(heroes))coverKeys.set('livre-'+hero+'.png','je-decouvre-'+suffix);
  for(const [hero,suffix] of Object.entries({clovis:'clovis',jeanne:'jeanne-d-arc',alienor:'alienor',napoleon:'napoleon',saintlouis:'saint-louis'}))coverKeys.set('mrmr-'+hero+'.png','mon-roi-ma-reine-'+suffix);
  function composition(handle,large=false){
    const parts=packs.get(handle);
    if(!parts||!parts.every(h=>products.get(h)?.image))return null;
    const group=document.createElement('span');
    group.className='esl-pack-composition'+(large?' esl-pack-composition--large':'');
    group.dataset.eslPack=handle;
    group.setAttribute('role','group');
    group.setAttribute('aria-label',products.get(handle)?.title||'Les deux puzzles');
    group.style.setProperty('--esl-cols',parts.length===2?2:parts.length>9?4:3);
    if(large)group.style.setProperty('--esl-pack-ratio',parts.length<=3?'1.6':'1.08');
    for(const h of parts){
      const p=products.get(h),im=document.createElement('img');
      im.src=p.image;im.alt=p.title;im.loading=large?'eager':'lazy';im.decoding='async';
      im.width=p.width;im.height=p.height;group.append(im);
    }
    return group;
  }
  const main=document.getElementById('pdpMain');
  const pageHandle=data.pageHandle||location.pathname.split('/products/')[1]?.split('/')[0];
  if(main&&packs.has(pageHandle)){
    const group=composition(pageHandle,true);
    if(group){
      main.before(group);main.classList.add('esl-visual-hidden');
      const buttons=[...document.querySelectorAll('.pdp__thumb')];
      buttons.forEach((button,i)=>{
        if(i===0){const mini=composition(pageHandle);mini.classList.add('esl-pack-composition--thumb');button.replaceChildren(mini)}
        button.addEventListener('click',()=>{group.classList.toggle('esl-pack-composition--hidden',i!==0);main.classList.toggle('esl-visual-hidden',i===0)});
      });
    }
  }
  function enhance(root){
    for(const im of root.querySelectorAll('img')){
      if(im===main||im.closest('.esl-pack-composition,.esl-book-stage,.pdp__thumb,.feuil-modal')||im.dataset.eslVisualDone)continue;
      const key=basename(im.getAttribute('src')||'');
      const cover=products.get(coverKeys.get(key));
      if(cover?.image){
        im.src=cover.image;im.removeAttribute('srcset');im.width=cover.width;im.height=cover.height;
        im.dataset.eslVisualDone='1';im.classList.add('esl-original-cover');continue;
      }
      const linked=im.closest('a[href*="/products/"]')?.getAttribute('href')?.split('/products/')[1]?.split(/[?#/]/)[0];
      const handle=imageKeys.has(key)&&packs.has(linked)?linked:imageKeys.get(key);
      if(!handle)continue;
      const group=composition(handle);
      if(group){im.dataset.eslVisualDone='1';im.replaceWith(group)}
    }
    for(const box of root.querySelectorAll('.vl__vign[style*="visuel-pack-decouverte.png"]')){
      if(box.dataset.eslVisualDone)continue;
      const group=composition('maxi-pack-univers');
      if(group){box.style.backgroundImage='none';box.classList.add('esl-pack-backdrop');box.closest('.vl__feu')?.classList.add('esl-pack-scene');box.dataset.eslVisualDone='1';box.prepend(group)}
    }
  }
  enhance(document);
  let scheduled=false;
  new MutationObserver(records=>{
    if(scheduled||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.classList.contains('esl-pack-composition'))))return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance(document)});
  }).observe(document.body,{childList:true,subtree:true});
})();

/* Presentation validee le 14/09/2026 : largeur ET hauteur du livre visible.
   Les PNG API et Clovis sont affiches entiers, sans retouche ni recadrage.
   Aucun traitement video. */
(()=>{
  'use strict';
  const data=window.ESL_PRODUCT_VISUALS;
  if(!data||!window.ResizeObserver||!CSS.supports('clip-path','polygon(0 0,100% 0,100% 100%)'))return;
  const outlines={
    'je-decouvre-clovis-ier':[1122,1402,[[102,79],[1021,79],[1062,104],[1070,130],[1070,1329],[1059,1355],[1037,1369],[107,1369],[94,1340],[93,91]]],
    'je-decouvre-sainte-clotilde':[800,1000,[[96,59],[696,59],[696,935],[684,938],[87,938],[82,922],[81,73],[85,63]]],
    'je-decouvre-alienor-d-aquitaine':[799,1000,[[88,59],[688,60],[688,934],[678,938],[80,938],[74,924],[73,74],[77,64]]],
    'je-decouvre-francois-ier':[802,1000,[[91,55],[686,55],[690,64],[690,934],[87,938],[80,922],[80,68],[83,59]]],
    'je-decouvre-jeanne-d-arc':[800,1000,[[93,62],[687,62],[687,941],[92,942],[82,935],[80,77],[84,67]]],
    'je-decouvre-napoleon-ier':[1125,1398,[[125,94],[973,94],[974,1318],[957,1325],[123,1326],[111,1316],[110,109],[115,99]]],
    'mon-roi-ma-reine-clovis':[1254,1254,[[171,135],[1080,72],[1106,80],[1106,1064],[190,1167],[171,1157]]],
    'mon-roi-ma-reine-saint-louis':[1254,1254,[[171,118],[1070,68],[1095,80],[1095,1080],[190,1167],[171,1158]]],
    'mon-roi-ma-reine-jeanne-d-arc':[1254,1254,[[169,117],[1065,66],[1091,78],[1087,1069],[187,1155],[169,1146]]],
    'mon-roi-ma-reine-napoleon':[1254,1254,[[169,118],[1070,67],[1095,79],[1095,1055],[188,1147],[169,1138]]],
    'mon-roi-ma-reine-alienor':[700,700,[[79,77],[620,50],[634,54],[633,577],[90,648],[81,643]]]
  };
  const apiBooks={
    'je-decouvre-clovis-ier':[1122,1402,94,80,1024,1320],
    'je-decouvre-sainte-clotilde':[1122,1402,96,80,1000,1303],
    'je-decouvre-alienor-d-aquitaine':[1121,1403,94,75,1024,1298],
    'je-decouvre-francois-ier':[1123,1401,98,81,1012,1341],
    'je-decouvre-jeanne-d-arc':[1122,1402,96,79,1023,1317],
    'je-decouvre-napoleon-ier':[1125,1398,112,90,991,1322]
  };
  const referenceBook=apiBooks['je-decouvre-clovis-ier'];
  const apiRatio=(referenceBook[4]-referenceBook[2])/(referenceBook[5]-referenceBook[3]);
  const apiExtent={
    width:Math.max(...Object.values(apiBooks).map(([iw,ih,x,y,r,b])=>2*Math.max((x+r)/2,iw-(x+r)/2)/(r-x)*apiRatio)),
    height:Math.max(...Object.values(apiBooks).map(([iw,ih,x,y,r,b])=>2*Math.max((y+b)/2,ih-(y+b)/2)/(b-y)))
  };
  const basename=url=>{try{return new URL(url,location.origin).pathname.split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/,'')}catch{return ''}};
  // Shopify suffixe les copies d'une meme couverture dans les galeries des packs.
  const coverBasename=url=>basename(url).replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.)/i,'');
  const keys=new Map();
  for(const p of data.products)if(outlines[p.handle])keys.set(coverBasename(p.image),p.handle);
  for(const handle of Object.keys(apiBooks))keys.set(handle+'-1.png',handle);
  keys.set('fc544b62cc45e481f74b1d82ad3b23ff.png','je-decouvre-napoleon-ier');
  for(const key of ['esl-clovis-original-1.png','clovis-couverture-nouvelle-edition.png','livre-clovis.png','je-decouvre-clovis-ier-1.png'])keys.set(key,'je-decouvre-clovis-ier');
  const states=new Map();
  const resize=new ResizeObserver(entries=>{
    for(const {target,contentRect:r} of entries){
      const state=states.get(target);if(!state)continue;
      const h=Math.max(0,state.api?Math.min(r.height*.96/apiExtent.height,r.width*.96/apiExtent.width):Math.min(r.height*.88,r.width*.9/state.familyRatio));
      state.shadow.style.width=(h*state.ratio)+'px';
      state.shadow.style.height=h+'px';
      state.shadow.style.setProperty('--esl-shadow-y',Math.max(.6,h*.009)+'px');
      state.shadow.style.setProperty('--esl-shadow-blur',Math.max(.8,h*.013)+'px');
    }
  });
  function unwrap(im,stage){
    resize.unobserve(stage);states.delete(stage);stage.replaceWith(im);
    im.classList.remove('esl-book-source');
  }
  function present(im){
    if(im.closest('.feuil-modal,video,picture')||im.matches('[data-esl-no-book]'))return;
    const handle=keys.get(coverBasename(im.getAttribute('src')||''));
    const existing=im.closest('.esl-book-stage');
    if(existing){if(existing.dataset.eslBook===handle)return;unwrap(im,existing)}
    if(!handle)return;
    const api=apiBooks[handle];
    const [iw,ih,points]=api?[api[0],api[1],[[api[2],api[3]],[api[4],api[3]],[api[4],api[5]],[api[2],api[5]]]]:outlines[handle];
    const xs=points.map(p=>p[0]),ys=points.map(p=>p[1]);
    const x=Math.min(...xs),y=Math.min(...ys),w=Math.max(...xs)-x,h=Math.max(...ys)-y;
    const stage=document.createElement('span'),shadow=document.createElement('span'),cutout=document.createElement('span');
    stage.className='esl-book-stage';stage.dataset.eslBook=handle;
    if(api)stage.classList.add('esl-book-stage--api');
    if(im.id==='pdpMain')stage.classList.add('esl-book-stage--main');
    if(im.classList.contains('feature__book'))stage.classList.add('esl-book-stage--feature');
    if(handle.startsWith('mon-roi'))stage.classList.add('esl-book-stage--small');
    shadow.className='esl-book-shadow';cutout.className='esl-book-cutout';
    if(!api)cutout.style.clipPath='polygon('+points.map(p=>((p[0]-x)/w*100)+'% '+((p[1]-y)/h*100)+'%').join(',')+')';
    stage.style.setProperty('--esl-source-width',(iw/w*100)+'%');
    stage.style.setProperty('--esl-source-height',(ih/h*100)+'%');
    stage.style.setProperty('--esl-source-left',(-x/w*100)+'%');
    stage.style.setProperty('--esl-source-top',(-y/h*100)+'%');
    im.before(stage);stage.append(shadow);shadow.append(cutout);cutout.append(im);
    im.classList.add('esl-book-source');
    states.set(stage,{shadow,ratio:api?apiRatio:w/h,familyRatio:handle.startsWith('mon-roi')?1:.8,api:!!api});resize.observe(stage);
  }
  function scan(){
    for(const [stage] of states)if(!stage.isConnected){resize.unobserve(stage);states.delete(stage)}
    document.querySelectorAll('img').forEach(present);
  }
  scan();
  let scheduled=false;
  new MutationObserver(records=>{
    if(scheduled||!records.some(r=>r.type==='attributes'||r.addedNodes.length||r.removedNodes.length))return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan()});
  }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['src']});
})();
